<app-default-card
  spyTarget="Info"
  [title]="''"
  [info]="''"
  [showChildComponent]="true"
  [showThisComponent]="true">
  Einen Moment bitte...
  <app-loading-overlay></app-loading-overlay>
</app-default-card>
